import React, { useState, useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import { HugeiconsIcon } from "@hugeicons/react";
import { PencilEdit02Icon } from "@hugeicons/core-free-icons";

export default function EditEmailModal({ show, onHide, prevEmail, onSubmit }) {
  const [newEmail, setNewEmail] = useState("");
  const [error, setError] = useState("");

  const emailRegex = useMemo(
    () => /^(?=.{1,254}$)(?=.{1,64}@)[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    []
  );

  const isValid = emailRegex.test(newEmail.trim());

  const validate = (val) => {
    if (!val.trim()) { setError("Email is required"); return false; }
    if (!emailRegex.test(val.trim())) { setError("Enter a valid email address"); return false; }
    setError("");
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate(newEmail)) return;
    onSubmit(newEmail.trim());
  };

  const handleHide = () => {
    setNewEmail("");
    setError("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide} centered dialogClassName="otp-edit-modal">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton className="border-0 pb-0">
          <div className="d-flex align-items-start gap-3">
            <div className="otp-modal-icon-wrapper">
              <HugeiconsIcon icon={PencilEdit02Icon} size={30} strokeWidth={1.6} />
            </div>
            <div className="pt-1">
              <div className="modal-title mb-1">Edit Email</div>
              <div className="text-muted" style={{ fontSize: "0.875rem", fontWeight: 400 }}>
                Please enter a valid email address
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <div className="mb-3">
            <label className="form-label">Previous Email</label>
            <input className="form-control" value={prevEmail || ""} readOnly />
          </div>
          <div className="mb-3">
            <label className="form-label">
              New Email <span className="text-danger">*</span>
            </label>
            <input
              className={`form-control ${error ? "is-invalid" : ""}`}
              type="email"
              value={newEmail}
              onChange={(e) => {
                setNewEmail(e.target.value.trimStart());
                validate(e.target.value.trimStart());
              }}
              onBlur={(e) => validate(e.target.value.trim())}
              placeholder="Enter new email address"
              autoComplete="email"
            />
            {error && <div className="invalid-feedback d-block">{error}</div>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleHide}>No, Cancel</Button>
          <Button variant="primary" type="submit" disabled={!isValid}>Update</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
